

export enum TimelineValueType {
    HOUR    = "hour",
    PERCENT = "percent",
}
